import { BASE_PATH } from "../env";

export function linkTo(appPath: string) {
  return BASE_PATH + appPath;
}